import { Modal } from 'antd';
import { ILineResource } from '../../entities/farms.entities';
import { Button, CloseIcon, Dropdown, Input, Subtitle } from '../shared';
import { useState } from 'react';
import { translate } from '../../lib/lang.helper';
import { useSelector } from 'react-redux';
import { selectLang } from '../../store/ui/ui.selector';
import { selectUtils } from '../../store/utils/utils.selector';
import { sendSingleRequest } from '../../apis';

interface Props {
  lineData: ILineResource;
  visible: boolean;
  onClose: () => void;
  loadData?: () => Promise<void>;
}

const LineMetaModal = ({ visible, onClose, lineData, loadData }: Props) => {
  const lang = useSelector(selectLang);
  const customers = useSelector(selectUtils)
    .filter(x => x.type === 'customer')
    .map(x => x.name);

  const [disabled, setDisabled] = useState(false);
  const [customer, setCustomer] = useState(lineData.customer ?? '');
  const [deliveredTo, setDeliveredTo] = useState(lineData.delivered_to ?? '');

  const confirmClick = async () => {
    setDisabled(true);
    const res = await sendSingleRequest(
      { customer, delivered_to: deliveredTo },
      'PUT',
      `api/farm/line-meta/${lineData.id}`,
      true,
    );
    if (res.status) {
      if (loadData) {
        loadData();
      }
      onClose();
    } else {
      window.alert(res.data?.message ?? 'Unknown error');
      setDisabled(false);
    }
  };

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      closable
      closeIcon={<CloseIcon />}
      footer={null}
    >
      <div className='wrap'>
        <div className='d-flex align-center mb-16'>
          <Subtitle color='black-1' align='left' size={1} fontWeight={600}>
            {translate(lang, '_schedule_line_designations')}
          </Subtitle>
        </div>
        <div className='mb-17'>
          <Subtitle color='black-2' align='left' size={0} fontWeight={500}>
            {translate(
              lang,
              'Select fields where harvest will be delivered and who it belongs to so you can filter it in reports',
            )}
          </Subtitle>
        </div>
        <div className='pt-16 pb-16'>
          <div className='mb-24'>
            <Input
              type='text'
              label={translate(lang, 'Delivered to')}
              placeholder=''
              value={deliveredTo}
              onChange={e => setDeliveredTo(e.target.value)}
            />
          </div>
          <div className='mb-24'>
            <Dropdown
              label={translate(lang, 'Customer')}
              value={customer}
              options={customers.map(x => ({ id: x, value: x, label: x }))}
              onChange={v => setCustomer(v)}
            />
          </div>
        </div>
      </div>
      <div className='modal-button d-flex justify-end align-center'>
        <Button
          className='mr-32'
          width={'small'}
          size={2}
          type='fill'
          color='red'
          disabled={disabled}
          onClick={onClose}
        >
          {translate(lang, 'Close')}
        </Button>
        <Button
          width={'small'}
          size={2}
          type='fill'
          color='green'
          disabled={disabled}
          onClick={confirmClick}
        >
          {translate(lang, 'Confirm')}
        </Button>
      </div>
    </Modal>
  );
};

export default LineMetaModal;
